import { api } from "@/lib/api";
import type { PageResponse } from "@/types/api";
import type {
    CreatePixelRequest,
    PixelDto,
    UpdatePixelRequest,
} from "@/types/pixel";

export interface ListParams {
    page?: number;
    size?: number;
    sort?: string;
    q?: string;
    provider?: string;
}

function paramsOf(p: ListParams = {}): Record<string, string | number> {
    const out: Record<string, string | number> = {};
    if (p.page != null) out.page = p.page;
    if (p.size != null) out.size = p.size;
    if (p.sort) out.sort = p.sort;
    if (p.q && p.q.trim()) out.q = p.q.trim();
    if (p.provider && p.provider !== "all") out.provider = p.provider;
    return out;
}

export async function listPixelsPaged(params: ListParams = {}): Promise<PageResponse<PixelDto>> {
    const { data } = await api.get<PageResponse<PixelDto>>("/admin/pixels", { params: paramsOf(params) });
    return data;
}

export async function getPixel(id: number): Promise<PixelDto> {
    const { data } = await api.get<PixelDto>(`/admin/pixels/${id}`);
    return data;
}

export async function createPixel(req: CreatePixelRequest): Promise<PixelDto> {
    const { data } = await api.post<PixelDto>("/admin/pixels", req);
    return data;
}

export async function updatePixel(id: number, req: UpdatePixelRequest): Promise<PixelDto> {
    const { data } = await api.patch<PixelDto>(`/admin/pixels/${id}`, req);
    return data;
}

export async function deletePixel(id: number): Promise<void> {
    await api.delete(`/admin/pixels/${id}`);
}

// ---- attachment helpers --------------------------------------------------

export async function listPixelsForCampaign(campaignId: number): Promise<PixelDto[]> {
    const { data } = await api.get<PixelDto[]>(`/admin/campaigns/${campaignId}/pixels`);
    return data;
}

export async function attachPixelToCampaign(campaignId: number, pixelId: number): Promise<void> {
    await api.post(`/admin/campaigns/${campaignId}/pixels/${pixelId}`);
}

export async function detachPixelFromCampaign(campaignId: number, pixelId: number): Promise<void> {
    await api.delete(`/admin/campaigns/${campaignId}/pixels/${pixelId}`);
}

export async function listPixelsForDomain(domainId: number): Promise<PixelDto[]> {
    const { data } = await api.get<PixelDto[]>(`/admin/domains/${domainId}/pixels`);
    return data;
}

export async function attachPixelToDomain(domainId: number, pixelId: number): Promise<void> {
    await api.post(`/admin/domains/${domainId}/pixels/${pixelId}`);
}

export async function detachPixelFromDomain(domainId: number, pixelId: number): Promise<void> {
    await api.delete(`/admin/domains/${domainId}/pixels/${pixelId}`);
}
